import CountryStateService from 'src/modules/countryState/countryStateService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'COUNTRYSTATE_VIEW';

const countryStateViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: countryStateViewActions.FIND_STARTED,
      });

      const record = await CountryStateService.find(id);

      dispatch({
        type: countryStateViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: countryStateViewActions.FIND_ERROR,
      });

      getHistory().push('/country-state');
    }
  },
};

export default countryStateViewActions;
